const STORAGE_KEY = "pontis-dms-quick-upload-history";
const MAX_ENTRIES = 300;

export type QuickUploadHistoryStatus = "success" | "fail";

export interface QuickUploadHistoryEntry {
  id: string;
  fileName: string;
  status: QuickUploadHistoryStatus;
  recordedAt: string;
}

function newId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function readQuickUploadHistory(): QuickUploadHistoryEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed
      .filter(
        (row): row is QuickUploadHistoryEntry =>
          row &&
          typeof row === "object" &&
          typeof (row as QuickUploadHistoryEntry).id === "string" &&
          typeof (row as QuickUploadHistoryEntry).fileName === "string" &&
          ((row as QuickUploadHistoryEntry).status === "success" ||
            (row as QuickUploadHistoryEntry).status === "fail") &&
          typeof (row as QuickUploadHistoryEntry).recordedAt === "string"
      )
      .slice(0, MAX_ENTRIES);
  } catch {
    return [];
  }
}

export function appendQuickUploadHistory(
  fileName: string,
  status: QuickUploadHistoryStatus
): QuickUploadHistoryEntry[] {
  const entry: QuickUploadHistoryEntry = {
    id: newId(),
    fileName,
    status,
    recordedAt: new Date().toISOString(),
  };
  const next = [entry, ...readQuickUploadHistory()].slice(0, MAX_ENTRIES);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Quota or private mode — still return in-memory tail for this session
  }
  return next;
}

export function clearQuickUploadHistory(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    if (localStorage.getItem(STORAGE_KEY) !== null) {
      localStorage.setItem(STORAGE_KEY, "[]");
    }
  } catch {
    try {
      localStorage.setItem(STORAGE_KEY, "[]");
    } catch {
      // ignore
    }
  }
}
